// Mapping between query parameter keys and XpressFormsHeader keys
export const queryToHeaderMap: Record<string, string> = {
  Lg: 'X-Lg-Code',
  Lc: 'X-Lc-Code',
  source_type: 'X-Referrer-Id',
}

export const createHeadersMap = (
  entries: Iterable<[string, string | string[] | undefined]>
) => {
  const map = new Map<string, string>()
  for (const [key, value] of entries) {
    if (key in queryToHeaderMap) {
      const headerKey = queryToHeaderMap[key]
      if (!headerKey || !value) {
        continue
      }
      const existingValue = map.get(headerKey)
      if (existingValue) {
        map.set(headerKey, [existingValue, value].join(','))
        continue
      }

      if (typeof value === 'string') {
        map.set(headerKey, value)
      } else if (Array.isArray(value) || existingValue) {
        map.set(headerKey, value.join(','))
      }
    }
  }
  return map
}
